import { render, staticRenderFns } from "./OrderLog.vue?vue&type=template&id=1bdfd314"
import script from "./OrderLog.vue?vue&type=script&lang=js"
export * from "./OrderLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports